import { render } from "./invoice.vue?vue&type=template&id=8228b902&scoped=true"
import script from "./invoice.vue?vue&type=script&lang=js"
export * from "./invoice.vue?vue&type=script&lang=js"

import "./invoice.vue?vue&type=style&index=0&id=8228b902&lang=scss&scoped=true"
import "./invoice.vue?vue&type=style&index=1&id=8228b902&lang=scss"

import exportComponent from "/Users/a/Desktop/app/pulizhenkong_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8228b902"]])

export default __exports__